<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Critical Course Score"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('critical_course_score')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Critical Course
      Score (External) Tool.
    </div>

    <!-------------------- CRITICAL COURSE SCORE HELP GUIDE -------------------->
    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Admin Support (External)
          <i class="fa-solid fa-arrow-right"></i> Critical Course Score External
          Page
        </h1>

        <h3 class="h3-second-header">
          Initial Results with Default Form Values
        </h3>

        <ul class="unordered-list">
          <li>
            Once you get to the external page, results will automatically
            generate based on the default values in the form fields on top of
            the page.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Goal for Critical Course Score tool</h3>

        <ul class="unordered-list">
          <li>
            Determine the best course timing and last possible time to pass
            courses for on-time students.
          </li>
          <li>
            The charts display information about the most frequently enrolled
            courses, optimal term to take a selected course, course sequences
            with critical course score that are determined by multiple criteria.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Critical Course Score Form Submission</h3>

        <ol class="ordered-list">
          <li><b>Course Popularity by Semester</b></li>
          <ul>
            <li>Select a degree program (Example: Mechanical Engineering)</li>
          </ul>
          <div>
            <p></p>
            <img
              class="set-img-width-sm"
              [(src)]="env['logo_paths']['helpPageCoursesAnalysis45']"
              alt=""
            />
            <p class="picture-caption">
              Figure 45: Course Popularity by Semester form field
            </p>
          </div>

          <li><b>Critical Course Timing</b></li>
          <ul>
            <li>Select a course (Example: ANT2000)</li>
          </ul>
          <div>
            <p></p>
            <img
              class="set-img-width-sm"
              [(src)]="env['logo_paths']['helpPageCoursesAnalysis46']"
              alt=""
            />
            <p class="picture-caption">
              Figure 46: Critical Course Timing form field
            </p>
          </div>

          <li><b>Historical Course Roadmaps</b></li>
          <ul>
            <li>Choose first year courses. (Example: EGS1006; MAC2312;)</li>
            <li>Select the range for cumulative attempted hours</li>
          </ul>
          <div>
            <p></p>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageCoursesAnalysis47']"
              alt=""
            />
            <p class="picture-caption">
              Figure 47: Historical Course Roadmaps form fields
            </p>
          </div>
        </ol>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Results after Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After you change the form fields’ values to your desired values, the
            form will automatically submit itself.
          </li>
          <li>
            The results will be regenerated based on the new input values.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <p></p>
        <img
          class="small-pics"
          [(src)]="env['logo_paths']['helpPageCoursesAnalysis48']"
          alt=""
        />
        <p class="picture-caption">
          Figure 48: Top 10 Most Enrolled Courses for Selected Program graph
        </p>
      </div>

      <div class="left-align-div">
        <p></p>
        <img
          class="small-pics"
          [(src)]="env['logo_paths']['helpPageCoursesAnalysis49']"
          alt=""
        />
        <p class="picture-caption">
          Figure 49: Critical Score and Enrollment/ On Time graph
        </p>
      </div>

      <div class="left-align-div">
        <p></p>
        <img
          class="small-pics"
          [(src)]="env['logo_paths']['helpPageCoursesAnalysis50']"
          alt=""
        />
        <p class="picture-caption">
          Figure 50: Historical Roadmap of Degree Program graph
        </p>
      </div>

      <div class="left-align-div">
        <p></p>
        <img
          class="small-pics"
          [(src)]="env['logo_paths']['helpPageCoursesAnalysis51']"
          alt=""
        />
        <p class="picture-caption">
          Figure 51: Course Deadline on On-Time Graduation graph
        </p>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getExternalAdminSupportRelatedLinkBasedOnTool(
        'Critical Course Score',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
